import React from "react";
import DatabaseSidebar from "../../components/database/DatabaseSidebar";
import DatabaseHeader from "../../components/database/DatabaseHeader";
import DatabaseContent from "../../components/database/DatabaseContent";
import { DatabaseProvider } from "../../components/database/DatabaseContext";
import "../../components/database/DatabasePage.css";
import "../../components/database/DatabaseModals.css";

const Database: React.FC = () => {
    return (
        <DatabaseProvider>
            <div className="databasePage">
                <DatabaseSidebar />
                <div className="dbMain">
                    <DatabaseHeader />
                    <DatabaseContent />
                </div>
            </div>
        </DatabaseProvider>
    );
};

export default Database;
